export default __webpack_public_path__ + "7b4366763f080ecb8dc219170d0ee102.svg";